// src/app/not-found.tsx
'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function NotFound() {
  const router = useRouter();

  useEffect(() => {
    const token = localStorage.getItem('access_token');

    if (!token) {
      router.replace('/login');
      return;
    }

    try {
      // Decodificar el token para conocer el rol
      const payloadBase64 = token.split('.')[1];
      const payloadDecoded = JSON.parse(atob(payloadBase64));

      if (payloadDecoded.role === 'ADMIN' || payloadDecoded.role === 'SUPERVISOR') {
        router.replace('/admin/dashboard');
      } else {
        router.replace('/cajero/panel');
      }
    } catch {
      localStorage.removeItem('access_token');
      router.replace('/login');
    }
  }, [router]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center space-y-3">
        <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto"></div>
        <p className="text-gray-500 dark:text-gray-400 text-sm font-medium">
          Verificando sesión y reorientando...
        </p>
      </div>
    </div>
  );
}